import { render, staticRenderFns } from "./MedicationDetail.vue?vue&type=template&id=4dc6f12e&scoped=true"
import script from "./MedicationDetail.vue?vue&type=script&lang=js"
export * from "./MedicationDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicationDetail.vue?vue&type=style&index=0&id=4dc6f12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6f12e",
  null
  
)

export default component.exports